import {Component, Input} from "@angular/core";
import {CommonModule} from '@angular/common';
import {FieldOkItemComponent} from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './abteilung.list-view.html',
    styleUrls: ['./abteilung.list-view.scss']
})
export class AbteilungListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {}
}
